import { TraitFieldsFragment } from 'types/generated';
import { ImageWithFocalPoint } from './ImageWithFocalPoint';
import { Check } from 'components/src/svg';
import { Subheading, Paragraph } from 'components/src/typography';
import { colors } from 'components/src/foundation';
import clsx from 'clsx';
import { gridGapClasses } from '@/styles/grid';

type Props = {
  trait: TraitFieldsFragment | null;
};

const Trait = ({ trait }: Props) => {
  return (
    trait?.id && (
      <div className={clsx(gridGapClasses, 'col-span-full flex md:col-span-6 md:p-16 lg:col-span-4')} key={trait.id}>
        {trait?.image && trait?.image?.id && (
          <div className="relative aspect-square h-[40px] w-[40px] rounded-28">
            <ImageWithFocalPoint className="" image={trait.image} sectionId={trait.id} sizes={{ default: '80px' }} />
          </div>
        )}
        <div className="flex flex-col gap-4">
          {trait?.title && (
            <Subheading bold small classes="text-black-10">
              {trait?.title}
            </Subheading>
          )}
          {trait?.description && <Paragraph classes="text-primary-faded-text-100">{trait?.description}</Paragraph>}
          {trait?.checkPoints?.map(
            (checkPoint?: string | null) =>
              checkPoint && (
                <div className="grid grid-flow-col items-center justify-start gap-8" key={`${trait.id}-${checkPoint}`}>
                  <Check color={colors.primary.grey} />
                  <Paragraph>{checkPoint}</Paragraph>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default Trait;
